import { render, staticRenderFns } from "./TiptapRadioItem.vue?vue&type=template&id=3a1914fe"
import script from "./TiptapRadioItem.vue?vue&type=script&lang=js"
export * from "./TiptapRadioItem.vue?vue&type=script&lang=js"
import style0 from "./TiptapRadioItem.vue?vue&type=style&index=0&id=3a1914fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
